import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/auth/register',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.logout = function (token) {
	return fetch({
		url: '/auth/logout',
		method: 'post',
		params: {
		},
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post'
	})
}

AuthService.aktivasi = function (data) {
	return fetch({
		url: '/auth/aktivasi',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.forgot = function (data) {
	return fetch({
		url: '/auth/forgot',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.reset = function (data) {
	return fetch({
		url: '/auth/reset',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

AuthService.proses_reset = function (data) {
	return fetch({
		url: '/auth/proses_reset',
		method: 'post',
		data: data,
		headers:{
			"x-api-key":X_API_KEY
		}
	})
}

export default AuthService;
